<template>
  <v-dialog v-model="orderProgress" persistent max-width="250">
    <v-card color="primary">
      <v-card-text class="py-2">
        <span class="white--text body-2">Processing... Please wait</span>
        <v-progress-linear
          :indeterminate="true"
          background-color="#fff"
          color="secondary"
          class="mt-1 mb-2"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "InProgress",
  props: {
    orderProgress: { type: Boolean, required: true }
  }
}
</script>

<style lang="scss" scoped>
</style>